module.exports = __webpack_public_path__ + "img/World Tourism Day 2016.43716be0.jpg";